import { useEffect, useState } from 'react';
import { MOBILE_SHEET_MAX_WIDTH } from '../utils/floatingPanelPosition';

/** True when viewport is narrower than the mobile sheet breakpoint (default 640px). */
export function useIsMobileViewport(breakpoint = MOBILE_SHEET_MAX_WIDTH) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
}
